<template>
  <base-dialog
    okText="导入"
    cancelText="关闭"
    @change="$emit('closeDiag')"
    @ok="importData"
    width="60%"
    style="height: 100%"
    title="数据导入"
    append-to-body
    v-model="visiable"
  >
    <div style="min-height: 300px">
      <base-form
        ref="baseFieldForm"
        class="baseFieldFormCss"
        v-model="formObj"
        labelWidth="80px"
        :rules="rules"
        :form-items="formItems"
      >
      </base-form>
      <import-data-dialog-upload
        ref="importUpload"
        :uploaderData="formObj"
        @closeDialog="$emit('closeDiag')"
      ></import-data-dialog-upload>
    </div>
  </base-dialog>
</template>
<script>
export default {
  name: 'import-data-dialog',
  props: {
    value: Boolean,
  },
  data() {
    var baseFormItem = {
      label: '列表类别',
      prop: 'id',
      component: 'form-select1',
      bind: {
        param: {
          data_type: 1,
        },
        sendJson: true,
        dataKey: {
          label: 'brand',
          value: 'id',
        },
      },
    }
    return {
      formObj: {},
      baseFormItem: baseFormItem,
      formItems: [
        {
          label: '查询类型',
          prop: 'type',
          component: 'form-select1',
          bind: {
            options: this.$getOptions('queryType'),
          },
          on: {
            change: this.formTypeChange,
          },
        },
        // {
        //     label: "语言",
        //     prop: "lang",
        // },
        baseFormItem,
      ],
      rules: {
        type: [
          {
            required: true,
            message: '请选择查询类型',
            trigger: 'blur',
          },
        ],
        id: [
          {
            required: true,
            message: '请选择列表类别',
            trigger: 'blur',
          },
        ],
      },
    }
  },
  computed: {
    visiable: {
      get() {
        return this.value
      },
      set(newVal) {
        this.$emit('closeDiag')
      },
    },
  },
  methods: {
    importData() {
      //验证表单
      this.$refs.baseFieldForm.validate((valid, obj) => {
        if (valid) {
          this.formObj.cre_user = this.$root.getNickName()
          this.$refs.importUpload.$refs.upload.submit()
        }
      })
    },
    refreshOption(val) {
      var baseFormItemNew = { ...this.baseFormItem }
      baseFormItemNew.bind.url = '/brandOrField/get'
      baseFormItemNew.bind.param.type = val
      return baseFormItemNew
    },
    formTypeChange(obj) {
      var that = this
      var baseFormItemNew = this.refreshOption(obj.val)
      this.formItems.splice(1, 1)
      this.$nextTick(() => {
        this.formItems.splice(1, 0, baseFormItemNew)
        this.formItems[0].value = obj.val
      })
    },
  },
}
</script>
<style lang="stylus" scoped>
.baseFieldFormCss {
}

>>>.baseFieldFormCss .el-form-item {
  width: 45%;
}

>>>.baseFieldFormCss .el-form-item__content {
  width: 70%;
}
</style>